import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { HOTEL_URL } from './constant/BaseApiUrl';

export default class HotelService {
  getHotels(hotel: any) {
    return axios.post(`${HOTEL_URL}${ApiKey.GET_HOTELS}`, hotel);
  }

  getHotelRoomCategory(payload: string) {
    return axios.post(`${HOTEL_URL}${ApiKey.GET_HOTEL_ROOM_CATEGORY}`, payload);
  }

  getListHotelFormDestination(destinationCode: string) {
    return axios.get(`${HOTEL_URL}${ApiKey.DESTINATION_GROUP}/${destinationCode}`);
  }

  getHotelRoomCategoryPreReg(payload: any) {
    return axios.post(`${HOTEL_URL}${ApiKey.HOTELS}/${ApiKey.PACKAGE_ROOM_CATEGORY}`, payload);
  }
}
